<template>
    <div id="teamCreateRequestPage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open" class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('team.create_request_title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <div class="d-flex justify-content-center my-4">
                        <img src="/images/home/teams/search-team-bg.png" class="vh-10" />
                    </div>

                    <h5 class="text-orange mb-0" v-html="$t('team.create_request_desc')"></h5>
                    <div><hr style="width: 3em;"/></div>

                    <div class="form-group mb-3 pl-3 pr-3 pl-md-5 pr-md-5">
                        <label for="teamName" class="mb-3">{{ $t('team.create_request_search_label') }}</label>
                        <b-form-input v-model="name" debounce="500" id="teamName" type="text" class="green-b text-center" size="lg"></b-form-input>
                    </div>

                    <p class="text-primary">{{ $t("team.create_request_list_label") }}</p>
                    
                    <div class="create-request-list">
                        <ul v-if="teams.length > 0" class="team-list">
                            <li v-for="r in teams" :key="r.id">
                                <h5 class="mb-0 ml-3">{{ r.name }}</h5>
                                <div class="team-list__right">
                                    <span class="memberCount">
                                        <img src="/images/icon-frends.png"/> <b>{{ r.memberCount }}</b>
                                    </span>
                                    <span class="selectTeam">
                                        <b-button @click="selectTeam(r);btnSfx();" size="sm" variant="success">
                                            <img src="/images/icon-add-user.png"/>
                                        </b-button>
                                    </span>
                                </div>
                            </li>
                        </ul>
                        <div v-else class="d-flex flex-fill p-3">
                            <span class="text-primary m-auto" v-html="$t('team.create_request_list_empty')"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

import api from '../../api'


const CreateRequestPopup = Vue.component('team-create-request-popup', {
    data() {
        return {
            open: false,
            name: "",
            teams: [],
            searched: null,
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show() {
            this.open = true;
            this.searched = null;
            this.name = "";
            this.search();
        },

        hide() {
            this.open = false;
        }, 

        search() {
            const $this = this;

            // same search
            if(this.searched == this.name.trim()) 
                return;

            // clear list
            this.teams = [];

            api.teams(this.name.trim()).then(res => {
                $this.teams = res.data;
                $this.searched = $this.name.trim();
            })
            .catch(err => {
                api.baseErrorHendler(err);
            });
        },
        
        selectTeam(team){
            const $this = this;

            this.$bvModal.msgBoxConfirm(this.$t('team.request_confirm_popup_text', { name: team.name }), {
                title: this.$t('team.request_confirm_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('team.request_confirm_popup_confirm_btn'),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal',
                okVariant: 'primary',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.teamsCreateRequest(team.id).then(res => {
                        $this.hide();
                        $this.$root.$bvModal.msgBoxOk($this.$t('team.request_send_popup_text'), {
                            title: $this.$t('team.request_send_popup_title'),
                            size: 'sm',
                            buttonSize: 'lg',
                            okTitle: $this.$t('base.btn_ok'),
                            modalClass: 'confirmModal',
                            hideHeaderClose: false,
                            centered: true
                        }).then(r => {
                            $this.$store.dispatch('sound/sfx','Button');
                        });
                    })
                    .catch(err => {
                        api.baseErrorHendler(err);
                    });
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        } 
    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        },
        name(){
            if(this.open) 
                this.search();
        }
    }
})

export default CreateRequestPopup
</script>